import React from "react";
import Select from "react-select";

const options = [
  { value: "smart_id", label: "Smart ID card" },
  { value: "id_book", label: "ID Book" },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: "6px",
    padding: "4px",
    borderColor: "hsl(var(--brand-primary))",
    boxShadow: "none",
    "&:hover": { borderColor: "hsl(var(--brand-secondary))" },
  }),
};

const CustomSelect = ({ selectedOption, setSelectedOption }) => {
  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={setSelectedOption}
      styles={customStyles}
      placeholder="Select an option..."
      isSearchable
    />
  );
};

export default CustomSelect;
